import './cell-item';
export default class FlexTableElement extends HTMLElement {
  constructor() {
    super();
  }
}
customElements.define('flex-table', FlexTableElement);